import { insertIf } from 'common'
import { MAX_DIPLAYED_FLAGGED_USERS_FOR_MULTISELECT } from 'constant'
import { getUserName } from 'services/Utilities'
import { OptionsType } from 'services/types'

import { t } from 'translations'

// Parsing function for flagged users to be used in multiselect
const getParsedUserForMultiSelect = (user: MData.UserWithFlags | MData.User) => {
  const { _id, employeeNumber, ...rest } = user
  return { _id, value: _id, label: getUserName(_id, { showEmployeeNumber: true }) ?? '', alt: { employeeNumber }, ...rest }
}

// Filtering function to return only eligible users
const filterEligibleUsers = (user: ReturnType<typeof getParsedUserForMultiSelect> | Option | OptionsType, event: MData.Event) => {
  if ('flags' in user) {
    const flags = user.flags as MData.UserWithFlags['flags']
    return flags.shiftFlags[event._id].isEligible
  }
}

type Option = { isHidden?: boolean; label: string; alt?: string; options?: Option[] } & Record<string, unknown>

const getParsedFlaggedUsersForMultiSelect = (options: (ReturnType<typeof getParsedUserForMultiSelect> | Option | OptionsType)[], event: MData.Event) => {
  const eligibleUsers = {
    label: t('manager.schedule.EDIT_MODAL.ELIGIBLE'),
    options: options.filter(user => filterEligibleUsers(user, event) && !user.archived)
  }
  const unEligibleUsers = {
    label: t('manager.schedule.EDIT_MODAL.NOT_ELIGIBLE'),
    options: options.filter(user => !filterEligibleUsers(user, event) && !user.archived)
  }
  return [eligibleUsers, unEligibleUsers]
}

const getDefaultOptionsForMultiSelect = (options: ReturnType<typeof getParsedUserForMultiSelect>[], event: MData.Event) => {
  const [eligibleUsers, unEligibleUsers] = getParsedFlaggedUsersForMultiSelect(options, event)

  if (eligibleUsers.options.length >= MAX_DIPLAYED_FLAGGED_USERS_FOR_MULTISELECT) {
    const displayedOptions = eligibleUsers.options.slice(0, MAX_DIPLAYED_FLAGGED_USERS_FOR_MULTISELECT)
    return [{ ...eligibleUsers, options: displayedOptions }]
  } else {
    const numberOfUnelibibleUsersToDisplay = MAX_DIPLAYED_FLAGGED_USERS_FOR_MULTISELECT - eligibleUsers.options.length
    const unEligibleUsersToDisplay = unEligibleUsers.options.slice(0, numberOfUnelibibleUsersToDisplay)
    return [...insertIf(!!eligibleUsers.options.length, eligibleUsers), { ...unEligibleUsers, options: unEligibleUsersToDisplay }]
  }
}

export { getParsedFlaggedUsersForMultiSelect, getParsedUserForMultiSelect, getDefaultOptionsForMultiSelect }
